/* eslint-disable */
import { observable, action } from 'mobx'
import axios from 'axios'

import Auth from './Auth'

import config from '../config'

class Settings {
  @observable settings = {}

  @action
  getSettings = () => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/settings/`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.settings = res.data
        return this.settings
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchSettings = (field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/settings/`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        this.settings = res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }
}

export default new Settings()



// WEBPACK FOOTER //
// ./src/stores/Settings.js